<template>
  <div :style="skeletonStyle" class="skeleton-loader"></div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    height: {
      type: String,
      default: '18px'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    skeletonStyle() {
      return {
        height: this.height,
        width: this.width,
      };
    }
  }
};
</script>

<style scoped>
.skeleton-loader {
  border-radius: 8px;
  background: linear-gradient(270deg, #EBECF0 0%, #FAFBFC 50%, #EBECF0 100%);
  background-color: #EBECF0;
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
